import script from "./Order_delete_button.vue?vue&type=script&setup=true&lang=js"
export * from "./Order_delete_button.vue?vue&type=script&setup=true&lang=js"

import "./Order_delete_button.vue?vue&type=style&index=0&id=35823c14&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-35823c14"]])

export default __exports__